var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobile-search-header",class:{
    'is-visible': _vm.isSearchMobileHeaderVisible(),
  }},[_c('div',{staticClass:"flex-l h-100 container mobile-search-header-container"},[_c('div',{staticClass:"flex justify-between items-center h-100 w-100"},[_c('SearchMobile')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }